import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6231 23H6.87685C5.01143 23 3.5 21.5018 3.5 19.6527V4.34732C3.5 2.49822 5.01143 1 6.87685 1H15.3423L20 5.63778V19.6527C20 21.5018 18.4886 23 16.6231 23Z",
			fill: "#5380C0"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 5.64008H16.2995C15.7755 5.64008 15.3493 5.21994 15.3493 4.70052L15.3423 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1446 9.23438H6.35498V9.92692H17.1446V9.23438Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1446 11.7231H6.35498V12.4157H17.1446V11.7231Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1446 14.2114H6.35498V14.904H17.1446V14.2114Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7486 16.7H6.35498V17.3925H11.7486V16.7Z",
			fill: "white"
		})
	]
});
export default SvgDoc;
